/* shipping accordion javascript */
var acc = document.getElementsByClassName("accordion");

for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        
        var panel = this.closest('p') ? 
                   this.closest('p').nextElementSibling : 
                   this.nextElementSibling;
        
        if (panel && panel.classList.contains('panel')) {
            if (panel.style.maxHeight && panel.style.maxHeight !== "0px") {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        } 
    });
}

var userlang = navigator.language || navigator.userLanguage;
console.log(`lang: ${userlang}`); // for shipping page customization

if (userlang.includes("ru") == true) {
    setTimeout(function() {
        $("#shipping-accordion-russia").click();
    }, 2000);
    console.log(`RU panel`);
} else if (userlang.includes("us") == true || userlang.includes("US") == true) {
    $("#shipping-accordion-us").click();
    $("#shipping-accordion-russia").click();
    console.log(`US-EN panel`);
}